import { render, staticRenderFns } from "./farm.vue?vue&type=template&id=1132d32f&scoped=true&"
import script from "./farm.vue?vue&type=script&lang=js&"
export * from "./farm.vue?vue&type=script&lang=js&"
import style0 from "./farm.vue?vue&type=style&index=0&id=1132d32f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132d32f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1132d32f')) {
      api.createRecord('1132d32f', component.options)
    } else {
      api.reload('1132d32f', component.options)
    }
    module.hot.accept("./farm.vue?vue&type=template&id=1132d32f&scoped=true&", function () {
      api.rerender('1132d32f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/farm.vue"
export default component.exports